module.exports = __webpack_public_path__ + "img/wallet.9a7d752c.png";